import { GET_L2s } from "../../Actions/ActionConstants";


function L2sReducer(state=null,action){
    switch (action.type) {
        case GET_L2s:
                if(action.data){return action.data;}
                else{return state}
        default:
            return state;
    }
}
export default L2sReducer